module.exports = __webpack_public_path__ + "images/website1-40c6761e6d7e9e8291afe7adbeeadf91.jpg";